export default "__VITE_ASSET__B$gjzwyV__"